<template>
  <div class="aditional-container round-container p-2">
    <div class="bg-white h-100 col-12">
      <ValidationObserver ref="observer" novalidate>
        <br />
        <div class="col-12 pb-0">
          <icon-view
            :has-border="false"
            icon="fas fa-file-alt color-orange"
            icon-size="1rem"
            title="Documentos"
            variant="custom-icon-view"
          />
          <div class="gray-box col-12 d-flex my-4 pb-2 align-items-start">
            <div class="col-4 pl-0">
              <label for class="d-block  text-gray text-left font-14"
                >Tipo de Documento:</label
              >
              <span class="data-content">
                {{ item.submittedDocumentTypeName }}
              </span>
            </div>
            <div class="col-5">
              <ValidationProvider
                v-slot="{ errors }"
                class="w-100 text-left"
                name="Archivo"
                rules="required"
              >
                <label for class="d-block bold text-left text-gray font-14"
                  >Archivo:</label
                >
                <CustomFileInput
                  ref="fileUpload3"
                  v-model="document.attachment"
                  :attachment-id="document.Id"
                  :accept="allowedFiles"
                  :value="document.attachment"
                  required
                  :error="errors[0]"
                  :name="document.name"
                  custom-error-msg="Favor de anejar el documento."
                  file-extension-error-msg="El documento anejado debe ser pdf."
                  maxSize="50"
                />
              </ValidationProvider>
            </div>
          </div>
          <div class="row m-3 text-gray">
            <span>
              Comentario:
            </span>
          </div>
          <div class="col-12 col-md-12 col-lg-12 py-1">
            <ValidationProvider
              v-slot="{ errors }"
              rules="required"
              mode="eager"
            >
              <CustomTextArea
                v-model="item.comment"
                :maxlength="3000"
                :rows="5"
                :show-char-count="true"
                :single-line="true"
                :error="errors[0]"
                custom-error-msg="Favor de entrar el comentario"
              />
            </ValidationProvider>
          </div>
          <div class="mx-3 my-3" v-if="showValidationErrors">
            <custom-error
              class="col-12 m-0"
              :is-alert-mode="true"
              message="Este proceso cuenta con reconocimiento de la información documentada en el archivo anejado. Si está seguro(a) que el documento anejado es correcto, favor oprimir el botón Documento Validado y volver a Guardar el documento."
            />
          </div>
          <div class="alert alert-danger mx-3" v-if="showValidationErrors">
            <ul class="m-0 pl-0 error-description" style="list-style-type:none">
              <li
                v-for="(error, index) in validationErrors"
                :key="`error-container-${index}`"
                class="color-primary-4"
              >
                <i class="fa fa-times-circle" aria-hidden="true" />
                &nbsp;
                <span class="font-16">{{ error }} </span>
              </li>
            </ul>
          </div>
        </div>
      </ValidationObserver>
      <div class="row">
        <div class="col-9"></div>
        <div class="col-3 pr-0 pt-0 mt-4 mb-4 pt-2 justify-content-end d-flex">
          <ActionButton
            id="btnCancel"
            variant="outline-danger mr-2"
            i="fas fa-times-circle"
            min-width="124px"
            @click="cancel"
          >
            Cancelar
          </ActionButton>
          <ActionButton
            id="btnSave"
            v-if="!showValidationErrors"
            variant="success mr-5"
            min-width="124px"
            @click="save"
          >
            Guardar
          </ActionButton>
          <ActionButton
            v-else
            id="btnSaveWithoutSkipValidation"
            variant="success mr-5 px-3"
            @click="save(true)"
            i="fa fa-check"
          >
            Documento Validado
          </ActionButton>
        </div>
      </div>
      <br />
    </div>
  </div>
</template>

<style scoped src="@/assets/css/component/panel-simple.css"></style>

<script>
import CustomFileInput from "CustomFileInput";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import alert from "@/mixin/alert.mixin";
import objectToFormData from "object-to-formdata";
import loading from "@/mixin/loading.mixin";
import { SectionTitle } from "@/components/pei/shared";
import { CustomTextArea, ActionButton } from "@/components/common";
import CustomError from "custom-error";
import IconView from "icon-view";
import { STIPULATION_TYPES } from "@/utils/constants/stipulationTypes";
export default {
  name: "AttachDocument",
  components: {
    CustomFileInput,
    ValidationObserver,
    ValidationProvider,
    ActionButton,
    SectionTitle,
    IconView,
    CustomTextArea,
    CustomError
  },
  mixins: [alert, loading],
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      document: {
        Id: null,
        documentTypeId: 0,
        attachment: null,
        name: "",
        date: new Date()
      },
      allowedFiles: ".pdf",
      documentTypes: [],
      selectedDocumentType: null,
      showReaseonDropDown: true,
      documentTypeCode: "EduEspStudentEvaluationDocumentType",
      errorMsgs: {
        type: "Favor seleccione.",
        comment: "Campo Requerido."
      },
      validationErrors: []
    };
  },
  methods: {
    getDataAsJson(skipDocumentValidation = null) {
      const data = {
        submittedDocumentRequirementId: this.item
          .submittedDocumentRequirementId,
        regionId: this.item.regionId,
        districtId: this.item.districtId,
        locationSchoolId: this.item.locationSchoolId,
        file: this.document.attachment,
        comment: this.item.comment,
        skipDocumentValidation: skipDocumentValidation
      };
      return objectToFormData(data, { indices: true });
    },
    async save(skipDocumentValidation = null) {
      const isCertificacionAsistente = (
        this.item.courtStipulationIds || []
      ).includes(STIPULATION_TYPES.CERTIFICACION_ASISTENTE);
      if (isCertificacionAsistente) {
        skipDocumentValidation = true;
      }

      if (!skipDocumentValidation) this.validationErrors = [];

      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        this.ShowToast(
          "Error",
          "Favor verificar y completar la información solicitada.",
          "error"
        );
        return;
      }

      if (skipDocumentValidation) {
        const confirmResult = await this.ShowCancelModal(
          "Confirmación",
          "¿Está seguro(a) que desea subir el documento validado?",
          "Sí",
          "No"
        );
        if (!confirmResult) return;
      }

      const data = this.getDataAsJson(skipDocumentValidation);

      this.$ApiPost(`api/rlvevidence/uploaddocument`, data)
        .then(response => {
          //update status
          if (response.data.length == 0)
            this.$emit("acceptUploadDocumment", this.item);
          else {
            this.validationErrors = response.data;
            this.ShowToast(
              "Error",
              "Documento anejado cuenta con errores.",
              "error"
            );
          }
        })
        .catch(err => {
          if (err && err.response && err.response.data)
            this.ShowToast("Error", err.response.data.message, "error");
          else this.ShowToast("Error", err.message, "error");
        });
    },
    async cancel() {
      this.$emit("cancelSubmitPanelEvidence", this.item);
    }
  },
  computed: {
    showValidationErrors() {
      return this.validationErrors.length > 0;
    }
  }
};
</script>
<style lang="scss" scoped>
.aditional-container {
  background-color: #f7f7f7;
}
.round-container {
  border-radius: 5px;
}
</style>
